define.alias("shared/components/shared/desktop-only-banner", "media/components/shared/desktop-only-banner");